module.exports = __webpack_public_path__ + "cc2430dd515292a75f87cdd0cecbde51.svg";